var _path, _rect, _rect2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Full Shift") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.08,1.94H11.92V3.27A.72.72,0,0,1,11.2,4h-1a.71.71,0,0,1-.71-.72V1.94h-4V3.27A.72.72,0,0,1,4.81,4h-1a.71.71,0,0,1-.71-.72V1.94H1.92a.87.87,0,0,0-.86.86V14a.86.86,0,0,0,.86.86H13.08a.86.86,0,0,0,.86-.86V2.8A.87.87,0,0,0,13.08,1.94ZM13,13.16a.66.66,0,0,1-.65.66H2.72a.67.67,0,0,1-.66-.66V5.68A.66.66,0,0,1,2.72,5h9.66a.65.65,0,0,1,.65.65Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.56,
    y: 0.19,
    width: 1.5,
    height: 3.3,
    rx: 0.24,
    ry: 0.24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.96,
    y: 0.19,
    width: 1.5,
    height: 3.3,
    rx: 0.24,
    ry: 0.24
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 9.5,
    r: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/full.f67d1dbf835e2cf218262639ef78fd89.svg";
export { ForwardRef as ReactComponent };